module.exports = __webpack_public_path__ + "img/toolbox.be087a12.webp";